import { FelaFlexbox } from "@gt/gt-frontend/build/react/vibescout-ui/fela/FelaFlexbox";
import { GraphSection, LegendItem } from "../components/Covid19Components";
import { colorsCovidPage } from "../Covid19Static";
import { MyResponsiveLine } from "../NivoChartTest";
import React from "react";

export const GraphTotalCasesAndActiveAndRecoveries = ({ caseItems }) => {
  // console.log(caseItems);

  return (
    <>
      <FelaFlexbox align={"center"} padding={0.5} justify={"space-between"}>
        <LegendItem name={"Total Cases"} color={colorsCovidPage.totalCases} />
        <LegendItem name={"Active Cases"} color={colorsCovidPage.newTests} />
        <LegendItem name={"Recoveries"} color={colorsCovidPage.totalRecoveries} />
      </FelaFlexbox>
      <FelaFlexbox style={{ height: "30vh", maxHeight: "22em" }}>
        <MyResponsiveLine
          yScaleExtras={{ min: 0 }}
          data={[
            {
              id: "Cases:",
              color: colorsCovidPage.totalCases,
              data: caseItems.map((item) => ({ x: item.date.slice(5), y: item.casesTotal })),
            },
            {
              id: "Recoveries:",
              color: colorsCovidPage.totalRecoveries,
              data: caseItems.map((item) => ({ x: item.date.slice(5), y: item.recoveriesTotal })),
            },
            {
              id: "Active:",
              color: colorsCovidPage.newTests,
              data: caseItems.map((item) => ({
                x: item.date.slice(5),
                y: item.casesTotal - (item.recoveriesTotal + item.deathsTotal),
              })),
            },
          ]}
        />
      </FelaFlexbox>
    </>
  );
};
